(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-scrollwatch", [], factory);
	else if(typeof exports === 'object')
		exports["vue-scrollwatch"] = factory();
	else
		root["vue-scrollwatch"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition